export default function CNewLines() {
  return <h2>C New Lines</h2>;
}
